<template>
  <div class="footer__contacts">
    <div class="footer__contacts-item">
      {{ company }}. {{ address }}. Register Number: {{ regNum }}
    </div>
    <div class="footer__contacts-bottom">
      <div class="footer__contacts-item">
        <div>
          Email: <a :href="`mailto:${mailTo}`">{{ mailTo }}</a>
        </div>
      </div>
      <div class="footer__contacts-item">
        <div>
          Telephone:
          <a :href="`tel:${phone.split(' ').join('')}`">{{ phone }}</a>
        </div>
      </div>
      <div class="footer__contacts-item">Customer Support 24/7</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: import.meta.env.VITE_COMPANY,
      address: import.meta.env.VITE_ADDRESS,
      country: import.meta.env.VITE_COUNTRY,
      regNum: import.meta.env.VITE_REG_NUM,
      phone: import.meta.env.VITE_PHONE,
      mailTo: import.meta.env.VITE_MAILTO,
    };
  },
};
</script>
